<div class="option-conteiner">
    <span [ngClass]="{'disabled': !isChecked}">{{option}}</span>
    <mat-slide-toggle [checked]="isChecked" (change)="setNewView($event)"></mat-slide-toggle>
</div>